import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import { Beat } from "../../../../redux/reducers/spinner";
import { cleanInput } from "../../../../redux/helpers";
import { adminActions } from "../../../../redux/actions";
import PrimaryLoader from "../../../includes/Loaders/PrimaryLoader";

export default function CompanySettings() {
  const dispatch = useDispatch();
  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;

  const {
    updatingSettings,
    loadingSettings,
    loadingCurrency,
    allCurrencies,
    companySettings,
  } = useSelector((state) => state.admin);

  const [data, setData] = useState({
    company_id: company_id,
    automatic_assignment: companySettings?.automatic_assignment ? 1 : 0,
    base_fee: companySettings?.base_fee || "",
    base_fee_per_meter: companySettings?.base_fee_per_meter || "",
    base_fees_by_delivery_mode: companySettings?.base_fees_by_delivery_mode || [],
    base_fees_per_kilogram: companySettings?.base_fees_per_kilogram || [],
    currency: companySettings?.currency || "",
    discount_percentage: companySettings?.discount_percentage || "",
    insurance_percentage: companySettings?.insurance_percentage || "",
    fee_per_meter_checkout: companySettings?.fee_per_meter_checkout ? 1 : 0,
    order_checkout: companySettings?.order_checkout ? 1 : 0,
    service_area_checkout: companySettings?.service_area_checkout ? 1 : 0,
    tax_percentage: companySettings?.tax_percentage || "",
    vat_percentage: companySettings?.vat_percentage || "",
    weight_limit_by_kilogram: companySettings?.weight_limit_by_kilogram || "",
    enforce_short_code: companySettings?.enforce_short_code ? 1 : 0,
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [currentDeliveryModeIndex, setCurrentDeliveryModeIndex] = useState(null);
  const [operatingTimeData, setOperatingTimeData] = useState({
    operating_status: "available",
    time_zone: "UTC+00:00",
    operating_time: {
      monday: { open: "", close: "" },
      tuesday: { open: "", close: "" },
      wednesday: { open: "", close: "" },
      thursday: { open: "", close: "" },
      friday: { open: "", close: "" },
      saturday: { open: "", close: "" },
      sunday: { open: "", close: "" },
    },
  });

  useEffect(() => {
    dispatch(adminActions.getApplicationSettings());
    dispatch(adminActions.getAllCurrencies());
    dispatch(adminActions.getACompanySettings(company_id));
  }, [dispatch, company_id]);

  useEffect(() => {
    if (companySettings) {
      setData({
        company_id: company_id,
        automatic_assignment: companySettings?.automatic_assignment ? 1 : 0,
        base_fee: companySettings?.base_fee || "",
        base_fee_per_meter: companySettings?.base_fee_per_meter || "",
        base_fees_by_delivery_mode: companySettings?.base_fees_by_delivery_mode || [],
        base_fees_per_kilogram: companySettings?.base_fees_per_kilogram || [],
        currency: companySettings?.currency || "",
        discount_percentage: companySettings?.discount_percentage || "",
        insurance_percentage: companySettings?.insurance_percentage || "",
        fee_per_meter_checkout: companySettings?.fee_per_meter_checkout ? 1 : 0,
        order_checkout: companySettings?.order_checkout ? 1 : 0,
        service_area_checkout: companySettings?.service_area_checkout ? 1 : 0,
        tax_percentage: companySettings?.tax_percentage || "",
        vat_percentage: companySettings?.vat_percentage || "",
        weight_limit_by_kilogram: companySettings?.weight_limit_by_kilogram || "",
        enforce_short_code: companySettings?.enforce_short_code ? 1 : 0,
      });
    }
  }, [companySettings, company_id]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle dynamic array fields for base_fees_per_kilogram
  const addKilogramFee = () => {
    setData((prev) => ({
      ...prev,
      base_fees_per_kilogram: [
        ...prev.base_fees_per_kilogram,
        { category: "", charge: "" },
      ],
    }));
  };

  const removeKilogramFee = (index) => {
    setData((prev) => ({
      ...prev,
      base_fees_per_kilogram: prev.base_fees_per_kilogram.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleKilogramFeeChange = (index, field, value) => {
    setData((prev) => ({
      ...prev,
      base_fees_per_kilogram: prev.base_fees_per_kilogram.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  // Handle dynamic array fields for base_fees_by_delivery_mode
  const addDeliveryModeFee = () => {
    setData((prev) => ({
      ...prev,
      base_fees_by_delivery_mode: [
        ...prev.base_fees_by_delivery_mode,
        { 
          title: "",
          category: "", 
          charge: "", 
          latitude: "", 
          longitude: "",
          operating_status: "available",
          time_zone: "UTC+00:00",
          operating_time: {
            monday: { open: "", close: "" },
            tuesday: { open: "", close: "" },
            wednesday: { open: "", close: "" },
            thursday: { open: "", close: "" },
            friday: { open: "", close: "" },
            saturday: { open: "", close: "" },
            sunday: { open: "", close: "" },
          },
        },
      ],
    }));
  };

  const removeDeliveryModeFee = (index) => {
    setData((prev) => ({
      ...prev,
      base_fees_by_delivery_mode: prev.base_fees_by_delivery_mode.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleDeliveryModeFeeChange = (index, field, value) => {
    setData((prev) => ({
      ...prev,
      base_fees_by_delivery_mode: prev.base_fees_by_delivery_mode.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  const openOperatingTimeModal = (index) => {
    setCurrentDeliveryModeIndex(index);
    const currentItem = data.base_fees_by_delivery_mode[index];
    setOperatingTimeData({
      operating_status: currentItem.operating_status || "available",
      time_zone: currentItem.time_zone || "UTC+00:00",
      operating_time: currentItem.operating_time || {
        monday: { open: "", close: "" },
        tuesday: { open: "", close: "" },
        wednesday: { open: "", close: "" },
        thursday: { open: "", close: "" },
        friday: { open: "", close: "" },
        saturday: { open: "", close: "" },
        sunday: { open: "", close: "" },
      },
    });
    setModalOpen(true);
  };

  const handleOperatingTimeChange = (day, field, value) => {
    setOperatingTimeData((prev) => ({
      ...prev,
      operating_time: {
        ...prev.operating_time,
        [day]: {
          ...prev.operating_time[day],
          [field]: value,
        },
      },
    }));
  };

  const saveOperatingTime = () => {
    if (currentDeliveryModeIndex !== null) {
      setData((prev) => ({
        ...prev,
        base_fees_by_delivery_mode: prev.base_fees_by_delivery_mode.map((item, i) =>
          i === currentDeliveryModeIndex
            ? {
                ...item,
                operating_status: operatingTimeData.operating_status,
                time_zone: operatingTimeData.time_zone,
                operating_time: operatingTimeData.operating_time,
              }
            : item
        ),
      }));
      setModalOpen(false);
      setCurrentDeliveryModeIndex(null);
    }
  };

  const handleUpdate = async () => {
    // Validate required fields
    // if (!data.company_id || !data.currency || !data.base_fee || !data.base_fee_per_meter) {
    //   alert("Please fill in all required fields: Company ID, Currency, Base Fee, and Base Fee Per Meter");
    //   return;
    // }

    // if (!data.insurance_percentage || !data.tax_percentage || !data.discount_percentage || !data.vat_percentage) {
    //   alert("Please fill in all percentage fields: Insurance, Tax, Discount, and VAT");
    //   return;
    // }

    // if (!data.weight_limit_by_kilogram) {
    //   alert("Please fill in Weight Limit by Kilogram");
    //   return;
    // }

    // Validate base_fees_by_delivery_mode if present
    if (data.base_fees_by_delivery_mode && data.base_fees_by_delivery_mode.length > 0) {
      const incompleteDeliveryMode = data.base_fees_by_delivery_mode.some(
        item => !item.title || !item.category || !item.charge || !item.latitude || !item.longitude ||
                !Object.values(item.operating_time).every(day => day.open && day.close)
      );
      if (incompleteDeliveryMode) {
        alert("Please complete all fields for Base Fees by Delivery Mode including operating times for all days");
        return;
      }
    }

    // Validate base_fees_per_kilogram if present
    if (data.base_fees_per_kilogram && data.base_fees_per_kilogram.length > 0) {
      const incompleteKilogram = data.base_fees_per_kilogram.some(
        item => !item.category || !item.charge
      );
      if (incompleteKilogram) {
        alert("Please complete all fields for Base Fees per Kilogram");
        return;
      }
    }

    // Clean the data before sending
    const cleanedData = { ...data };
    
    // Remove empty base_fees_by_delivery_mode if array is empty or has empty items
    if (cleanedData.base_fees_by_delivery_mode && cleanedData.base_fees_by_delivery_mode.length === 0) {
      delete cleanedData.base_fees_by_delivery_mode;
    } else if (cleanedData.base_fees_by_delivery_mode) {
      // Filter out incomplete delivery mode entries
      cleanedData.base_fees_by_delivery_mode = cleanedData.base_fees_by_delivery_mode.filter(
        item => item.title && item.category && item.charge
      );
      // If after filtering it's empty, remove the field
      if (cleanedData.base_fees_by_delivery_mode.length === 0) {
        delete cleanedData.base_fees_by_delivery_mode;
      }
    }

    // Remove empty base_fees_per_kilogram if array is empty or has empty items
    if (cleanedData.base_fees_per_kilogram && cleanedData.base_fees_per_kilogram.length === 0) {
      delete cleanedData.base_fees_per_kilogram;
    } else if (cleanedData.base_fees_per_kilogram) {
      // Filter out incomplete kilogram entries
      cleanedData.base_fees_per_kilogram = cleanedData.base_fees_per_kilogram.filter(
        item => item.category && item.charge
      );
      // If after filtering it's empty, remove the field
      if (cleanedData.base_fees_per_kilogram.length === 0) {
        delete cleanedData.base_fees_per_kilogram;
      }
    }

    cleanInput(cleanedData);
    const response = dispatch(adminActions.updateCompanySettings({ ...cleanedData }));
    if (response.status === "success") {
      dispatch(adminActions.getACompanySettings(company_id));
    }
  };

  return (
    <>
      {loadingSettings ? (
        <PrimaryLoader />
      ) : (
        <>
          <div className="w-100 mx-auto">
            <div className="mx-auto bg-white dark:bg-[#121212] sm:w-[630px] w-full mt-10 sm:mt-0 sm:border p-6 sm:border-gray-200 dark:border-none">
              <div className="border-b-2 dark:border-[#505050] py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                  Update Company Settings
                </p>
              </div>

              <form>
                <div className=" sm:px-10 mb-10">
                  <div className="row">
                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="automatic_assignment">
                        Automatic assignment
                      </label>
                      <select
                        className="form-control"
                        name="automatic_assignment"
                        value={data?.automatic_assignment}
                        onChange={handleChange}
                      >
                        <option value="">Select option</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="enforce_short_code">
                        Enforce short code
                      </label>
                      <select
                        className="form-control"
                        name="enforce_short_code"
                        value={data?.enforce_short_code}
                        onChange={handleChange}
                      >
                        <option value="">Select option</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="base_fee">Base Fee</label>
                      <input
                        type="text"
                        className="form-control"
                        name="base_fee"
                        onChange={handleChange}
                        value={data?.base_fee}
                        placeholder={"0.0"}
                      />
                    </div>
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="base_fee_per_meter">
                        Base fee per meter
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="base_fee_per_meter"
                        onChange={handleChange}
                        value={data?.base_fee_per_meter}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>

                  {/* Base Fees Per Kilogram - Dynamic Form */}
                  <div className="row">
                    <div className="col-md-12 mb-4">
                      <label className="font-weight-bold">
                        Base Fees Per Kilogram
                      </label>
                      {data?.base_fees_per_kilogram?.map((item, index) => (
                        <div key={index} className="border p-3 mb-3 rounded">
                          <div className="row">
                            <div className="col-md-5">
                              <label htmlFor={`category_${index}`}>
                                Category
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.category}
                                onChange={(e) =>
                                  handleKilogramFeeChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                                placeholder="e.g., fragile"
                              />
                            </div>
                            <div className="col-md-5">
                              <label htmlFor={`charge_${index}`}>Charge</label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.charge}
                                onChange={(e) =>
                                  handleKilogramFeeChange(
                                    index,
                                    "charge",
                                    e.target.value
                                  )
                                }
                                placeholder="0.0"
                              />
                            </div>
                            <div className="col-md-2 d-flex align-items-end">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removeKilogramFee(index)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={addKilogramFee}
                      >
                        + Add Kilogram Fee
                      </button>
                    </div>
                  </div>

                  {/* Base Fees By Delivery Mode - Dynamic Form */}
                  <div className="row">
                    <div className="col-md-12 mb-4">
                      <label className="font-weight-bold">
                        Base Fees By Delivery Mode
                      </label>
                      {data?.base_fees_by_delivery_mode?.map((item, index) => (
                        <div key={index} className="border p-3 mb-3 rounded">
                          <div className="row">
                            <div className="col-md-6 mb-2">
                              <label htmlFor={`title_${index}`}>Title</label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.title}
                                onChange={(e) =>
                                  handleDeliveryModeFeeChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                placeholder="e.g., Enugu North"
                              />
                            </div>
                            <div className="col-md-6 mb-2">
                              <label htmlFor={`category_${index}`}>Category</label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.category}
                                onChange={(e) =>
                                  handleDeliveryModeFeeChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                                placeholder="e.g., Express Delivery"
                              />
                            </div>
                            <div className="col-md-6 mb-2">
                              <label htmlFor={`charge_${index}`}>Charge</label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.charge}
                                onChange={(e) =>
                                  handleDeliveryModeFeeChange(
                                    index,
                                    "charge",
                                    e.target.value
                                  )
                                }
                                placeholder="0.0"
                              />
                            </div>
                            <div className="col-md-5 mb-2">
                              <label htmlFor={`latitude_${index}`}>
                                Latitude
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.latitude}
                                onChange={(e) =>
                                  handleDeliveryModeFeeChange(
                                    index,
                                    "latitude",
                                    e.target.value
                                  )
                                }
                                placeholder="16.972741"
                              />
                            </div>
                            <div className="col-md-5 mb-2">
                              <label htmlFor={`longitude_${index}`}>
                                Longitude
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={item.longitude}
                                onChange={(e) =>
                                  handleDeliveryModeFeeChange(
                                    index,
                                    "longitude",
                                    e.target.value
                                  )
                                }
                                placeholder="12.378865"
                              />
                            </div>
                            <div className="col-md-12 mb-2">
                              <button
                                type="button"
                                className="btn btn-info btn-sm mr-2"
                                onClick={() => openOperatingTimeModal(index)}
                              >
                                Set Operating Time
                              </button>
                              {item.operating_time && 
                               Object.values(item.operating_time).every(day => day.open && day.close) && (
                                <span className="text-success ml-2">
                                  ✓ Operating time configured
                                </span>
                              )}
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removeDeliveryModeFee(index)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={addDeliveryModeFee}
                      >
                        + Add Delivery Mode Fee
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="currency">Currency</label>
                      <select
                        className="form-control"
                        name="currency"
                        value={data?.currency || ""}
                        onChange={handleChange}
                      >
                        <option>Select Currency</option>
                        {loadingCurrency ? (
                          <option>Loading...</option>
                        ) : (
                          Object.keys(allCurrencies).map((key) => (
                            <option
                              key={allCurrencies[key]?.id}
                              value={allCurrencies[key]?.alphabetic_code}
                            >
                              {allCurrencies[key]?.alphabetic_code}
                            </option>
                          ))
                        )}
                      </select>
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="discount_percentage">
                        Discount percentage
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="discount_percentage"
                        onChange={handleChange}
                        value={data?.discount_percentage}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="insurance_percentage">
                        Insurance percentage
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="insurance_percentage"
                        onChange={handleChange}
                        value={data?.insurance_percentage}
                        placeholder={"0.0"}
                      />
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="fee_per_meter_checkout">
                        Fee per meter checkout
                      </label>
                      <select
                        className="form-control"
                        name="fee_per_meter_checkout"
                        value={data?.fee_per_meter_checkout}
                        onChange={handleChange}
                      >
                        <option value="">Select Status</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="order_checkout">Order checkout</label>
                      <select
                        className="form-control"
                        name="order_checkout"
                        value={data?.order_checkout}
                        onChange={handleChange}
                      >
                        <option value="">Select Status</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="service_area_checkout">
                        Service area checkout
                      </label>
                      <select
                        className="form-control"
                        name="service_area_checkout"
                        value={data?.service_area_checkout}
                        onChange={handleChange}
                      >
                        <option value="">Select Status</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="tax_percentage">Tax percentage</label>
                      <input
                        type="text"
                        className="form-control"
                        name="tax_percentage"
                        onChange={handleChange}
                        value={data?.tax_percentage}
                        placeholder={"0.0"}
                      />
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="vat_percentage">Vat percentage</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vat_percentage"
                        onChange={handleChange}
                        value={data?.vat_percentage}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="weight_limit_by_kilogram">
                        Weight limit by kilogram
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="weight_limit_by_kilogram"
                        onChange={handleChange}
                        value={data?.weight_limit_by_kilogram}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="flex justify-center mx-auto">
            <MDBBtn color="primary" type="button" onClick={handleUpdate}>
              {updatingSettings ? (
                <Beat loading={updatingSettings} />
              ) : (
                "Update Settings"
              )}
            </MDBBtn>
          </div>
        </>
      )}

      {/* Operating Time Modal */}
      <MDBModal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
        <MDBModalHeader toggle={() => setModalOpen(!modalOpen)}>
          Set Operating Time
        </MDBModalHeader>
        <MDBModalBody>
          <div className="p-3">
            <div className="row mb-4">
              <div className="col-md-6">
                <label htmlFor="operating_status">Operating Status *</label>
                <select
                  className="form-control"
                  value={operatingTimeData.operating_status}
                  onChange={(e) =>
                    setOperatingTimeData((prev) => ({
                      ...prev,
                      operating_status: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="available">Available</option>
                  <option value="unavailable">Unavailable</option>
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="time_zone">Time Zone *</label>
                <input
                  type="text"
                  className="form-control"
                  value={operatingTimeData.time_zone}
                  onChange={(e) =>
                    setOperatingTimeData((prev) => ({
                      ...prev,
                      time_zone: e.target.value,
                    }))
                  }
                  placeholder="UTC+00:00"
                  required
                />
              </div>
            </div>

            <h6 className="mb-3">Weekly Operating Hours</h6>
            {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map(
              (day) => (
                <div key={day} className="row mb-3">
                  <div className="col-md-4 d-flex align-items-center">
                    <label className="mb-0 text-capitalize font-weight-bold">
                      {day}
                    </label>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor={`${day}_open`}>Open *</label>
                    <input
                      type="time"
                      className="form-control"
                      value={operatingTimeData.operating_time[day].open}
                      onChange={(e) =>
                        handleOperatingTimeChange(day, "open", e.target.value)
                      }
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor={`${day}_close`}>Close *</label>
                    <input
                      type="time"
                      className="form-control"
                      value={operatingTimeData.operating_time[day].close}
                      onChange={(e) =>
                        handleOperatingTimeChange(day, "close", e.target.value)
                      }
                      required
                    />
                  </div>
                </div>
              )
            )}

            <div className="d-flex justify-content-end mt-4">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={saveOperatingTime}
              >
                Save Operating Time
              </button>
            </div>
          </div>
        </MDBModalBody>
      </MDBModal>
    </>
  );
}
